const articles = [
  {
    title:
      "Generative Adversarial Networks Based Segmentation Model for Acute Lymphoblastic Leukemia Detection",
    publisher:
      "International Conference on Research Trends in AI and IoT for Infrastructure and Industry by Centre for Research, Anna University, Chennai",
    link: "https://www.aucfrconference.com/aiiii2024",
    daterange: "March 2024",
    points: [
      "This study introduces a novel approach for detecting Acute Lymphoblastic Leukemia (ALL) cells through a custom GAN-based segmentation model, achieving high accuracy rates for both healthy and blast cells. Utilizing HSV color space for precise color representation and synthetic image generation, the model outperforms established models like Attention U-Net, U²Net, and SegNet. The integration of DC-GAN enhances dataset quality, positioning GAN as a promising tool for future applications in medical image analysis and classification.",
    ],
  },
  {
    title:
      "Integrating Custom GAN Segmentation with Advanced Deep Learning Classifiers for Enhanced Acute Lymphoblastic Detection",
    publisher:
      "2024 Tenth International Conference on Bio Signals, Images, and Instrumentation in IEEE",
    link: "https://doi.org/10.1109/ICBSII61384.2024.10564063",
    daterange: "June 2024",
    points: [
      "The study integrates custom GAN segmentation with advanced deep learning classifiers to enhance acute lymphoblastic leukemia (ALL) detection. By utilizing public single-cell datasets and Generative Adversarial Networks, the research achieves high segmentation accuracy for healthy and blast cells. The work further explores the impact of segmentation on classification accuracy, showcasing notable improvements in model performance. The study introduces innovative methodologies for ALL cell detection, emphasizing the importance of timely leukemia detection for optimizing treatment outcomes.",
    ],
  },
];

export default articles;
